import Vue from "vue";

const state = Vue.observable({
  visibleWindows: [],
  windowsSize: {},
});

export function onTaskBarItemClick(windowName) {
  if (state.visibleWindows[0] === windowName) minimizeWindow(windowName);
  else state.visibleWindows = [windowName, ...state.visibleWindows];
}
export function showWindow(windowName) {
  if (!state.visibleWindows.includes(windowName))
    state.visibleWindows = [windowName, ...state.visibleWindows];
}
export function bringWindowToFront(windowName) {
  if (state.visibleWindows.includes(windowName))
    state.visibleWindows = [
      windowName,
      ...state.visibleWindows.filter(item => item !== windowName),
    ];
}
export function minimizeWindow(windowName) {
  state.visibleWindows = state.visibleWindows.filter(
    item => item !== windowName
  );
}

export default state;
